import { BaSeA11yBar, BaSeTheme } from '@base/react';
import * as React from 'react';
import { ReactComponent as LogoSebrae } from '../../images/ico-sebrae.svg';
import { AcessibilidadeBar, azulFluxoCaixa, LinkLogo } from './layout-styled';

export const AccessibilityBar = () => {
  const { white } = BaSeTheme.colors.defaultColors;

  return (
    <AcessibilidadeBar>
      <BaSeA11yBar
        backgroundColor={azulFluxoCaixa}
        delimitedOnBreakpoint="desktop"
        foregroundColor={white}
        iconColor={white}
        borderColor={white}
        logoInverseColor
        localeLanguageOptions={[]}
        renderLogo={() => (
          <LinkLogo
            href="https://sebrae.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LogoSebrae />
          </LinkLogo>
        )}
      />
    </AcessibilidadeBar>
  );
};
